import styled from "styled-components";

const ComposeStyle = styled.div`
  .compose-breadcrumb {
    font-size: 14px;
    color: #636980;
    margin-bottom: 16px;
  }

  .compose-breadcrumb .crumb-link {
    cursor: pointer;
    color: #636980;
  }

  .compose-breadcrumb .crumb-link:hover {
    color: #1f243b;
  }

  .compose-breadcrumb .crumb-current {
    color: #1f243b;
    font-weight: 500;
  }

  .original-message-block {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
  }

  .original-message-block.no-border {
    border-bottom: none;
  }

  .attachment-card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 16px;
    margin-top: 20px;
  }

  .attachment-card {
    background: #f5f5f6;
    border-radius: 8px;
    padding: 16px;
    display: block;
    text-decoration: none;
    cursor: pointer;
  }

  .attachment-card-title {
    margin: 0 0 16px;
    color: #1f243b;
    font-weight: 500;
    font-size: 14px;
  }

  .attachment-card-file-row {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #636980;
    font-size: 13px;
  }

  .attachment-pdf-icon {
    color: #ff4d4f;
    font-size: 20px;
  }

  .original-message-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }

  .original-message-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #2bb791;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    flex-shrink: 0;
  }

  .original-message-from {
    margin: 0;
    color: #1f243b;
    font-weight: 500;
  }

  .original-message-date {
    margin: 0;
    color: #636980;
    font-size: 13px;
  }

  .original-message-subject {
    margin: 0 0 8px;
    color: #1f243b;
    font-size: 16px;
    font-weight: 600;
  }

  .original-message-body {
    margin: 0;
    color: #636980;
    white-space: pre-wrap;
    line-height: 1.6;
  }

  .compose-field {
    margin-bottom: 20px;
  }

  .compose-field-label {
    display: block;
    margin-bottom: 8px;
    color: #1f243b;
    font-weight: 500;
  }

  .compose-recipients .ant-select-selector {
    border-radius: 8px !important;
    /* min-height: 44px !important; */
  }

  .compose-subject-input,
  .ant-input.compose-subject-input {
    height: 44px;
    border-radius: 8px;
  }

  /* Message field - one bordered box holding the toolbar, the text area
     and the attachment chips, as in the design. */
  .compose-editor-wrapper {
    border: 1px solid #e2e4e9;
    border-radius: 8px;
    overflow: hidden;
    background: #ffffff;
  }

  .compose-editor-toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 14px;
    background: #f5f5f6;
  }

  .compose-editor-toolbar-btn {
    border: none;
    background: transparent;
    cursor: pointer;
    color: #1f243b;
    font-size: 14px;
    width: 26px;
    height: 26px;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .compose-editor-toolbar-btn:hover:not(:disabled) {
    background: #e6e7ea;
  }

  .compose-editor-toolbar-btn.active {
    background: #dcdde2;
  }

  .compose-editor-toolbar-btn:disabled {
    color: #b0b3bf;
    cursor: not-allowed;
  }

  .compose-font-size-input {
    width: 40px;
    height: 26px;
    border: 1px solid #e2e4e9;
    border-radius: 4px;
    background: #ffffff;
    text-align: center;
    font-size: 14px;
    color: #1f243b;
    outline: none;
  }

  .compose-font-size-input:focus {
    border-color: #2bb791;
  }

  .compose-attach-btn {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: transparent;
    color: #1f243b;
    cursor: pointer;
    font-size: 14px;
  }

  .compose-attach-btn:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .compose-attach-icon {
    flex-shrink: 0;
  }

  .compose-editor-body {
    min-height: 200px;
    padding: 14px;
    outline: none;
    color: #1f243b;
    font-size: 14px;
    line-height: 1.6;
  }

  .compose-editor-body:empty::before {
    content: attr(data-placeholder);
    color: #b0b0b0;
  }

  /* Tailwind's preflight strips list markers - restore them so the
     numbered/bullet list buttons visibly do something. */
  .compose-editor-body ul,
  .original-message-body ul {
    list-style: disc;
    padding-left: 20px;
    margin: 8px 0;
  }

  .compose-editor-body ol,
  .original-message-body ol {
    list-style: decimal;
    padding-left: 20px;
    margin: 8px 0;
  }

  .original-message-body li {
    white-space: normal;
  }

  .compose-attachments {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px 24px;
    padding: 0 14px 14px;
  }

  .compose-attachment-chip {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-width: 0;
    height: 28px;
    padding: 0 10px;
    background: #ffffff;
    border: 1px solid #e2e4e9;
    border-radius: 4px;
    font-size: 13px;
    color: #1f243b;
  }

  .compose-attachment-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .compose-attachment-remove {
    flex-shrink: 0;
    cursor: pointer;
    color: #1f243b;
    font-size: 11px;
    display: inline-flex;
  }

  @media (max-width: 992px) {
    .compose-attachments {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  .compose-footer {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-top: 24px;
  }

  .compose-cancel,
  .compose-send {
    min-width: 130px;
    height: 40px;
    border-radius: 8px;
    font-size: 16px;
    cursor: pointer;
  }

  .compose-cancel {
    background: #ffffff;
    border: 1px solid #1f243b;
    color: #1f243b;
  }

  .compose-send {
    background: #c2fae5;
    border: none;
    color: #1f243b;
  }

  .compose-send:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .compose-cancel:hover,
  .compose-send:not(:disabled):hover {
    background: #a9f2d8 !important;
  }
`;

export default ComposeStyle;
